import React from 'react';
import { useAssessmentContext } from 'js/engines/CapabilitiesAssessment/AssessmentContext';
import { getPageTitle } from 'js/engines/CapabilitiesAssessment/utils';

import styles from './Page.module.scss';

/** A page's title and description, at the top of its first card. */
function PageHeader({ page }) {
  const { capabilitySets } = useAssessmentContext();

  return (
    <div className={styles['page-header']}>
      <h2 className={styles['page-title']}>
        {getPageTitle(page, capabilitySets)}
      </h2>
      {page.description && (
        <p className={styles['page-description']}>{page.description}</p>
      )}
    </div>
  );
}

export default PageHeader;
